/**
 * 工厂译制集合成员判定（前后端共用单点）：某行 `novels.source_provider` 是否指向工厂译制平台。
 *
 * 契约源：dev-docs `03-数据字典/20-内容.md` §1 `edition_label` —— 成员判据 = `source_provider` 指向
 * `kind = 'TRANSLATION_FACTORY'` 的 provider（与 `03-数据字典/110-采集.md` §5.1 同一口径），随提供方
 * 改写实时进出集合。ADM-BOK-S024 的成员分支（回显跟随译制基准行 / 拒绝成员写入标签 / 改入集合时清空）
 * 与 Web 编辑面的只读判定都经本函数求值。
 *
 * **kind 的权威是 `content_providers.kind`**。admin 侧尚未接入该表，受理的 provider 仍是
 * `SourceProviderSchema` 闭集（`TENTOO` = 外部内容方，不是工厂译制平台），故本判定按该闭集求值：
 * 闭集内的工厂译制平台集合为空。provider 改为配置驱动（读 `content_providers.kind`）由
 * novel-admin#649 承接；工厂译制行的译制任务同事务义务见 novel-admin#666。
 *
 * 放 shared 而非 server：server 的写入校验 / 回显解析与 Web 编辑面的只读判定必须是同一个判据，
 * 分开写时一端改成配置驱动、另一端仍按旧闭集，就会出现「输入框可编辑但保存被拒」。
 */

/** admin 当前受理的 provider 闭集中 `kind = 'TRANSLATION_FACTORY'` 的 code 集合。 */
export const TRANSLATION_FACTORY_PROVIDER_CODES: ReadonlySet<string> = new Set<string>();

/** `source_provider` 为工厂译制平台 → true；`null`（未配提供方）与外部内容方 → false。 */
export function isTranslationFactoryProviderCode(code: string | null | undefined): boolean {
  return code != null && TRANSLATION_FACTORY_PROVIDER_CODES.has(code);
}
